import dayjs, { Dayjs } from 'dayjs';
import { dateFormat } from '../../tools/date';

const hoursAfterMidnightIsStillTheDayBefore = 3;

export const todayWithTolerance = () => {
  let currentDate = dayjs();
  // 3am is basically still yesterday :D
  if (currentDate.hour() < hoursAfterMidnightIsStillTheDayBefore) {
    console.log('today is still yesterday!')
    currentDate = currentDate.subtract(1, 'day');
  }
  return currentDate.format(dateFormat);
}
